module.exports = __webpack_public_path__ + "img/strat.71875d94.svg";